module.exports = __webpack_public_path__ + "img/法国站.48e1db80.png";